import React from "react";
import { Switch, Route } from "react-router-dom";
import App from "./App";
import Test from "./Test";

const Routes = (
  <Switch>
    <Route path="/" exact component={App} />
    <Route path="/test" exact component={Test} />
  </Switch>
);
export default Routes;
